import * as z from 'zod';

export const TrainingSpecialtiesSchema = z.object({
    "id": z.number(),
    "is_active": z.boolean(),
    "name": z.string(),
    "code": z.number()
});

export const TrainingSpecialtiesPartialSchema = TrainingSpecialtiesSchema.partial();
export type TrainingSpecialtiesPartial = z.infer<typeof TrainingSpecialtiesPartialSchema>;
export type TrainingSpecialties = z.infer<typeof TrainingSpecialtiesSchema>;

export function newTrainingSpecialties(data: unknown) {
    if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }

    if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }

    return {
        ...TrainingSpecialtiesSchema.parse({...data})
    };
}

export function parseTrainingSpecialties(data: any, partial = false) {
    if (!partial) {
        return {
            ...TrainingSpecialtiesSchema.parse(data)
        };
    }
    else if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }
    else if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    else if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }
    else {
        return {
            ...TrainingSpecialtiesPartialSchema.parse(data)
        };
    }
}
